let dirAudio = 'games/page008_game1/audio/';

let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page008_game2/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page008_game1/audio/false.mp3',
    positive: 'games/page008_game1/audio/true.mp3',
    click: 'games/page008_game1/audio/click.mp3',
    icon: {
      on: 'games/page008_game1/img/audioOn.png',
      off: 'games/page008_game1/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 48,
    height: 48,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 165,
    height: 305,
  },
  layoutItems: [
    {
      pos: {
        x: 670,
        y: 680,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 811,
        y: 160,
      },
    },
    {
      pos: {
        x: 1334,
        y: 160,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page008_game1/audio/11_green.mp3',
          correct: {
            image: {
              src: 'games/page008_game2/img/cup_green.png',
            },
            width: 432,
            height: 493,
            correctItems: {
              images: [
                {
                  src: 'games/page008_game1/img/ramka_zielona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 444,
                  height: 505,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page008_game2/img/cup_pink.png',
            },
            width: 432,
            height: 493,
            incorrectItems: {
              images: [
                {
                  src: 'games/page008_game1/img/ramka_czerwona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 444,
                  height: 505,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  staticMaskConfig: [
    {
      id: 'm1',
      pos: {
        y: 106,
        x: 100,
      },
      unit: 'px',
      click: { src: dirAudio + 'click.mp3' },
      src: 'games/page008_game1/img/folia.png',
    },
  ],
};

export default elements;
